<h3>Support Map Pie Chart</h3>

<div class="card flex justify-content-center pie-width">
  <p-chart
    type="pie"
    [data]="data"
    [options]="options"
    [style.background-color]="bgColor"></p-chart>
</div>
